module.exports = __webpack_public_path__ + "images/kihnu/apple-icon-72x72.png";